import { Component, OnInit, Input } from "@angular/core";
import { ChartType } from "chart.js";
import { ChartDataSets, ChartOptions } from "chart.js";
import { MultiDataSet, Label, Color, Colors } from "ng2-charts";
import * as pluginDataLabels from "chartjs-plugin-datalabels";
import * as pluginAnnotations from "chartjs-plugin-annotation";

import * as _moment from "moment";
import { EstadoGestionModel } from "src/app/models/estadoGestion.model";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-chart-state",
  templateUrl: "./chart-state.component.html",
  styleUrls: ["./chart-state.component.scss"]
})
export class ChartStateComponent implements OnInit {

  public dataCurrentClients: any;
  public mangementState = new EstadoGestionModel();
  public percentManagementState = new EstadoGestionModel();

  public totalObligations = 0;
  public amountObligations = 0;
  public dataAverage = [];
  public dataManagementState = [];

  // Chart
  public lineChartData: ChartDataSets[] = [
    {
      data: [],
      label: "",
      yAxisID: "y-axis-1",
      lineTension: 0,
      fill: true,
      borderWidth: 1
    }
  ];
  public lineChartLabels: Label[] = [];
  public lineChartOptions: ChartOptions & { annotation: any } = {
    responsive: true,
    elements: {
      point: {
        radius: 7,
        hitRadius: 5,
        hoverRadius: 10,
        hoverBorderWidth: 2
      }
    },
    scales: {
      // Dynamic theming.
      xAxes: [
        {
          gridLines: {
            color: "transparent",
            drawOnChartArea: true
          },
          ticks: {
            display: true,
            beginAtZero: true
          }
        }
      ],
      yAxes: [
        {
          id: "y-axis-0",
          position: "left",
          gridLines: {
            color: "#EDEDED",
            drawOnChartArea: true
          },
          ticks: {
            display: false,
            beginAtZero: true,
            max: 100
          }
        },
        {
          id: "y-axis-1",
          position: "right",
          gridLines: {
            color: "transparent",
            drawOnChartArea: false
          },
          ticks: {
            fontColor: "#4A4A4A",
            display: false,
            // max: 5,
            min: 0
            // stepSize: 10
          }
        }
      ]
    },
    annotation: {
      annotations: [
        {
          type: "line",
          mode: "vertical",
          scaleID: "x-axis-0",
          value: "March",
          borderColor: "orange",
          borderWidth: 1,
          label: {
            enabled: true,
            fontColor: "orange",
            content: "LineAnno"
          }
        }
      ]
    },
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          let sum = 0;
          const dataArr: any = this.lineChartData[0].data;
          dataArr.map((data: any) => {
            sum += data;
          });
          const percentage: any = ((value * 100) / sum).toFixed(2) + "%";
          return percentage;
        },

        render: "percentage",
        color: "transparent",
        anchor: "end",
        align: "left",
        font: {
          size: 12
        }
      }
    }
  };
  public lineChartColors: Color[] = [
    {
      // Orange
      backgroundColor: "transparent",
      borderColor: "#E5703A",
      pointBackgroundColor: "#E5703A",
      pointBorderColor: "#E5703A",
      pointHoverBackgroundColor: "#E5703A",
      pointHoverBorderColor: "#E5703A"
    }
  ];
  public lineChartLegend = false;
  public lineChartType: ChartType = "line";
  public lineChartPlugins = [pluginAnnotations];
  // ./Chart

  constructor(private spinner: NgxSpinnerService) {}

  ngOnInit() {}

  getStateManagements(data: any) {
    // Cant
    this.dataCurrentClients = data || [];

    const arrTemp = this.dataCurrentClients.map(({ respuesta }) => respuesta);

    this.mangementState = {
      renuente:
        arrTemp.filter(
          (item: any) => item === "Renuente , no acepta valor y/o obligación"
        ).length || 0,
      reclamo:
        arrTemp.filter(
          (item: any) =>
            item === "Reclamo pendiente respuesta/aclaración del afiliado"
        ).length || 0,
      promesa: arrTemp.filter((item: any) => item === "Promesa").length || 0,
      posibleAcuerdo:
        arrTemp.filter(
          (item: any) => item === "Posible acuerdo / volver a llamar"
        ).length || 0,
      pagoParcial:
        arrTemp.filter((item: any) => item === "Pago Parcial").length || 0,
      ilocalizado: arrTemp.filter(
        (item: any) => item === "Gestion telefonica sin localización deudor"
      ).length,
      mensajes:
        arrTemp.filter(
          (item: any) => item === "Mensajes con tercero / Volver a llamar"
        ).length || 0,
      gestionDigital:
        arrTemp.filter(
          (item: any) => item === "Gestión Digital"
        ).length || 0,
      pagoTotal:
        arrTemp.filter((item: any) => item === "Pago Total").length || 0,
      otros: arrTemp.filter((item: any) => item === undefined).length || 0
    };

    this.dataManagementState = Object.values(this.mangementState);
    this.lineChartData[0].data = this.dataManagementState;

    // Percent
    const total = arrTemp.length || 100;

    this.lineChartLabels = [
      `Renuente: ${Number((this.mangementState.renuente * 100) / total).toFixed(
        2
      )}%`,
      `Reclamo: ${Number((this.mangementState.reclamo * 100) / total).toFixed(
        2
      )}%`,
      `Promesa: ${Number((this.mangementState.promesa * 100) / total).toFixed(
        2
      )}%`,
      `Posible Acuerdo: ${Number(
        (this.mangementState.posibleAcuerdo * 100) / total
      ).toFixed(2)}%`,
      `Pago Parcial: ${Number(
        (this.mangementState.pagoParcial * 100) / total
      ).toFixed(2)}%`,
      `Ilocalizado: ${Number(
        (this.mangementState.ilocalizado * 100) / total
      ).toFixed(2)}%`,
      `Mensajes: ${Number((this.mangementState.mensajes * 100) / total).toFixed(
        2
      )}%`,
      `Gestión digital: ${Number(
        (this.mangementState.gestionDigital * 100) / total
      ).toFixed(2)}%`,
      `Otros: ${Number((this.mangementState.otros * 100) / total).toFixed(2)}%`
    ];

    this.spinner.hide("gestiones");
  }
}
